<template>
    <div class="contents">

        <label v-bind:class="cssLabel">
            <slot name="label"></slot>
        </label>

        <select
        :required="required"
        :style="style"
        :disabled="disabled"
        :class="cssInput"
        @change="$emit('update:value', $event.target.value); $emit('selected', options.find(item => item.value == $event.target.value))"
        >

            <option
            value=""
            v-if="emptyOption"
            >{{ __('labels.basics.choose_option') }}</option>

            <option
            v-for="option in options"
            :value="option[this.valueKey]"
            :key="option.value"
            :disabled="option.disabled"
            :selected="value == option[this.valueKey]"
            >
                <div v-if="baseLabel == false">
                        {{ option.name }}
                </div>
                <div v-else>
                    {{ __(baseLabel +"."+option.name) }}
                </div>
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        value: [String, Number],
        style: String,
        predefinedStyle: {
            type: String,
            default : "default"
        },
        required: {
            type: Boolean,
            default: false
        },
        options: Array,
        emptyOption: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: [String, Boolean],
            default: false
        },
        baseLabel: {
            type: [String, Boolean],
            default: false
        },
        valueKey : {
            type: String,
            default: "value",
        }
    },
    emits: [
        "update:value",
    ],
    data() {
        return {
            predefinedStyles: {
                default: {
                    label: "text-base text-stone-900 dark:text-slate-100 font-bold mb-1",
                    input: {
                        "w-full" : true,
                        "text-base" : true,
                        "outline-none" : true,
                        "border-2" : true,
                        "border-gray-200" : true,
                        "dark:border-transparent" : true,
                        "dark:hover:border-slate-500" : true,
                        "dark:focus-visible:border-slate-500" : true,
                        "focus-visible:border-accent-color" : true,
                        "rounded-md" : true,
                        "py-1.5" : true,
                        "px-3" : true,
                        "dark:bg-gray-700": !this.disabled,
                        "dark:bg-gray-900": this.disabled,
                        "bg-neutral-100": this.disabled,
                        "cursor-not-allowed" : this.disabled,
                    }

                },
                sidemenu: {
                    label: "text-base text-stone-900 dark:text-slate-100 font-bold mb-1",
                    input: {
                        "w-full" : true,
                        "bg-accent-color " : true,
                        "text-white " : true,
                        "outline-none " : true,
                        "border-2 " : true,
                        "border-sky-900" : true,
                        "dark:border-transparent " : true,
                        "dark:hover:border-slate-500 " : true,
                        "dark:focus-visible:border-slate-500 " : true,
                        "focus-visible:border-accent-color " : true,
                        "rounded-md py-1.5 " : true,
                        "px-3 " : true,
                        "text-base" : true,
                        "dark:bg-gray-700": !this.disabled,
                        "dark:bg-gray-900": this.disabled,
                        "bg-neutral-100": this.disabled,
                        "cursor-not-allowed" : this.disabled,
                    }

                }
            }
        };
    },
    computed: {
        cssLabel: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle]["label"];
            }
            return this.predefinedStyles["default"]["label"];
        },
        cssInput: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle]["input"];
            }
            return this.predefinedStyles["default"]["input"];
        }
    }
}
</script>
